// extracted by mini-css-extract-plugin
export default {"reportsHomeWrapper":"ReportsHome_reportsHomeWrapper__WCM7O","reportsTabsWrapper":"ReportsHome_reportsTabsWrapper__HDwx2"};